<template>
  <div class="point-set-container relative h-full">
    <div class="left h-full pt-8px" v-show="showRiskForm">
      <div class="cameras p-8px">
        <div class="flex items-center">
          <h3 class="mr-8px">设备位置设置</h3>
          <el-select
            placeholder="选择设备类型"
            v-model="deviceType"
            size="mini"
            class="mr-8px"
            @change="deviceTypeChange"
          >
            <el-option
              v-for="item in deviceTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-if="loadModelType === 'modelFileId'"
            placeholder="选择模型"
            v-model="modelFileId"
            :disabled="!modelLoaded"
            @change="handleModelChange"
          >
            <el-option
              v-for="item in modelList"
              :key="item.Name"
              :label="item.Name"
              :value="item.FileId"
            ></el-option>
          </el-select>
          <el-select
            v-else
            v-model="sceneId"
            placeholder="场景"
            :disabled="!modelLoaded"
            @change="handleSceneChange"
          >
            <el-option
              v-for="item in sceneList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
          <i
            class="el-icon-setting text-28px primary-blue ml-10px cursor-pointer"
            @click="openSetting"
          ></i>
        </div>
        <el-divider class="mt-10px mb-10px"></el-divider>
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <span class="w-2px h-16px bg-$buttonPrimaryBg inline-block mr-10px"></span>
            <span class="text-16px text-$titleTextColor">设备列表</span>
          </div>
          <div class="flex items-center">
            <el-switch
              @change="switchStatus"
              v-model="renderStatus"
              active-color="#409eff"
              inactive-color="#ccc"
            >
            </el-switch>
            <span class="ml-5px">查看</span>
          </div>
        </div>
        <div class="mt-8px flex items-center">
          <el-input
            style="width: 150px;"
            class="mr-8px"
            v-model="KeyWord"
            size="mini"
            placeholder="请输入设备名称"
            clearable
            @keypress.enter.native="getList"
          ></el-input>
          <el-select
            placeholder="位置类型"
            v-model="IsPosition"
            size="mini"
            class="mr-8px"
            clearable
          >
            <el-option label="已设置位置" :value="true"></el-option>
            <el-option label="未设置位置" :value="false"></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="getList">搜索</el-button>
          <!-- <el-button size="small" type="primary">导出</el-button> -->
          <!-- <el-button size="small" type="primary">导入</el-button> -->
          <el-button
            size="small"
            type="danger"
            :disabled="!$hasAccess('delete')"
            @click="delMultiple"
            >清空</el-button
          >
        </div>
        <div class="camera-container mt-8px">
          <el-table
            ref="table"
            border
            highlight-current-row
            @row-click="rowClick"
            @selection-change="selectionChange"
            :data="tableData"
            height="calc(100% - 180px)"
          >
            <el-table-column :align="alignType" type="selection" width="60"></el-table-column>
            <el-table-column
              :align="alignType"
              label="序号"
              prop="seqNo"
              width="80"
            ></el-table-column>
            <el-table-column
              label="设备名称"
              prop="name"
              :show-overflow-tooltip="true"
              :align="alignType"
            ></el-table-column>
            <el-table-column label="位置设置" width="90" :align="alignType">
              <template slot-scope="{ row }">
                <div>{{ row.isSetPosition ? '√' : '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="设置有效范围" width="110" :align="alignType">
              <template slot-scope="{ row }">
                <div>{{ row.isSetMonitorRange ? '√' : '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90" :align="alignType">
              <template slot-scope="{ row }">
                <el-tooltip content="位置设置" placement="top">
                  <i
                    class="el-icon-setting text-20px cursor-pointer mr-5px"
                    @click.stop="editHandle(row)"
                  ></i>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <i
                    class="el-icon-delete text-20px cursor-pointer"
                    @click.stop="delRowData(row)"
                  ></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px text-right right-2 bottom-2 absolute"
            small
            background
            layout="total, sizes, prev, pager, next"
            :total="initPagination.total"
            :current-page.sync="initPagination.pageNum"
            :page-size="initPagination.pageSize"
            :pager-count="5"
            :page-sizes="[15, 30, 45, 90, 450]"
            @current-change="currentChange"
            @size-change="sizeChange"
          >
          </el-pagination>
        </div>
      </div>
      <editDialog
        ref="editDialog"
        v-if="editDialogShow"
        :show.sync="editDialogShow"
        :detailRow="detailRow"
        :relevanceDevices.sync="relevanceDevices"
        :type="editType"
        :modelLoaded="modelLoaded"
        :perspective="ruleForm.perspective"
        :currentPosition="currentPosition"
        :player="player"
        :basicIconList="basicIconList"
        :deviceTypeInfo="deviceTypeInfo"
        :pointInfo="pointInfo"
        :modelFileId="modelFileId"
        :sceneId="sceneId"
        @reload="getList"
        @on-position-change="handlePosition"
        @on-cancel-dev-edit="handleCancelDevEdit"
        @open-device-detail="openDeviceDetail"
      ></editDialog>
    </div>
    <div class="right relative" v-loading="loading">
      <!-- <ModelView
        ref="modelViewRef"
        class="model-w"
        :perspective="ruleForm.perspective"
        :moduleName="moduleName"
        @getPosition="getPosition"
        @camarePosition="cameraPosition"
        @loadModelEnd="loadModelEnd"
      ></ModelView> -->

      <ModelView
        ref="modelViewRef"
        class="w-full h-full"
        :cloudRender="cloudRender"
        :loadModelType="loadModelType"
        @loadModelEnd="loadModelEnd"
        :modelFileInfo="modelFileInfo"
        :sourceId="sceneId"
        @sendPlayer="sendPlayer"
      ></ModelView>
      <BottomTool :player="player" :cloudRender="cloudRender" v-if="modelLoaded"></BottomTool>
    </div>
    <!-- 收缩按钮 -->
    <div
      :style="showRiskForm ? 'left:636px;' : 'left:0px;'"
      class="risk_icon absolute w-24px h-24px bg-$buttonPrimaryBg top-20px cursor-pointer"
    >
      <i
        class="operate_tree w-24px h-24px text-white z-1000 text-center"
        :class="showRiskForm ? 'el-icon-d-arrow-left expand_icon' : 'el-icon-d-arrow-right'"
        @click="showRiskForm = !showRiskForm"
      ></i>
    </div>
    <configDialog
      v-if="showMini"
      :show.sync="showMini"
      :deviceTypeCode="deviceType"
      :basicIconList="basicIconList"
      :effectIconList="effectIconList"
      :player="player"
      :deviceTypeInfo="deviceTypeInfo"
      :basicImgType="basicImgType"
      :effectImgType="effectImgType"
      @reload="handleSaveSuccess"
    ></configDialog>
    <relevanceDevicesDialog
      v-if="showRelevanceDevices"
      :show.sync="showRelevanceDevices"
      :relevanceDevices.sync="relevanceDevices"
    ></relevanceDevicesDialog>
  </div>
</template>

<script>
import { instance as cloudRender } from 'wiz-cloud-render'
import { Tag3DPositionApi, Tag3DPositionImgApi } from '@wiz-api/tag-3d-position-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { ModelSceneApi } from '@wiz-api/scene-management'
import ModelView from '@/components/model/ModelView'
import api from '@/services/pageService/modelListApi'
import BottomTool from '@/components/model/bottomTool/index'
import editDialog from './editDialog'
import configDialog from './configDialog'
import relevanceDevicesDialog from './relevanceDevicesDialog'

const tag3DPositionManagementAPI = new Tag3DPositionApi()
const dataCategoryApi = new DataCategoryApi()
const tag3DPositionImgApi = new Tag3DPositionImgApi()
const modelSceneApi = new ModelSceneApi()

export default {
  name: 'pointSet',
  components: {
    ModelView,
    editDialog,
    configDialog,
    relevanceDevicesDialog,
    BottomTool,
  },
  props: {
    // 模块名称；被哪个模块引用，就传哪个模块的名称进来，用于获取配置文件里的三维模型信息
    moduleName: {
      type: String,
      default: 'wiz-tag-3d-position-management-tongre',
    },
  },
  data() {
    return {
      sceneList: [], // 场景列表
      sceneId: '',
      deviceTypeInfo: {},
      iconTypeList: [], // 图标类型列表(基础图标、效果图标)
      basicImgType: '', // 字典里获取的基础图标id
      effectImgType: '', // 字典里获取到的效果图标id
      basicIconList: [], // 基础图标列表
      addBasicIconList: [], // 存放新上传的基础图标
      editBasicIconList: [], // 存放编辑上传的基础图标
      delBasicIconList: [], // 存放删除的基础图标
      effectIconList: [], // 动效图标列表
      addEffectIconList: [], // 存放新上传的效果图标
      editEffectIconList: [], // 存放编辑上传的效果图标
      delEffectIconList: [], // 存放删除的效果图标
      showRiskForm: true,
      deviceTypeList: [], // 设备类型
      IsPosition: null, // 位置设置状态
      renderStatus: false, // 是否开启在三维里查看
      deviceType: '', // 设备类型
      modelFileId: '',
      modelList: [], // 三维模型列表
      modelFileInfo: {},
      alignType: 'left',
      KeyWord: '',
      videoDialogShow: false,
      cameraMsg: {},
      tableData: [],
      editDialogShow: false,
      editType: 'add',
      currentPosition: [],
      modelLoaded: false,
      perspective: {},
      saveLoading: false,
      loading: false,
      cameraMarkerList: [], // 摄像头标记信息
      cameraMarkerIds: [], // 摄像头标记ID
      textMarkerList: [], // 摄像头名称标记
      textMarkerIds: [],
      detailRow: {},
      orderBy: '',
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      height: 360,
      player: null,
      ruleForm: {
        eye: '',
        target: '',
        up: '',
        perspective: {},
      },
      moduleAuth: null,
      selectionList: [], // 复选框勾选的数据
      showMini: false, // 控制设置弹窗
      pointInfo: null, // 点击三维获取到的点相关的信息
      showRelevanceDevices: false, // 关联设备弹窗
      relevanceDevices: [], // 关联设备列表
    }
  },
  watch: {
    cameraMarkerList(val) {
      this.delMarkers()
      this.createCameraMarker()
      this.delTextMarkers()
      if (Array.isArray(val) && val.length > 0) {
        val.forEach((item) => {
          this.createTextMakers(item)
        })
      }
    },
  },
  computed: {
    wizIotConfig() {
      return Wiz.globalSettings.dynamicModules?.modules[this.moduleName]?.config || {}
    },
    loadModelType() {
      return this.wizIotConfig.loadModelType === 'modelFileId' ? 'modelFileId' : 'sceneId'
    },
    cloudRender() {
      return cloudRender
    },
    fileTypeMap() {
      const basicFileTypeMap = this.basicIconList.reduce((map, cur) => {
        map[cur.fileId] = cur.originalFileName
        return map
      }, {})
      const effectFileTypeMap = this.effectIconList.reduce((map, cur) => {
        map[cur.fileId] = cur.originalFileName
        return map
      }, {})
      return {
        ...basicFileTypeMap,
        ...effectFileTypeMap,
      }
    },
  },
  methods: {
    // 用于控制场景下拉的禁用，当切换场景时，下拉框禁用，直到模型加载完毕才可以操作下拉
    handleSceneChange() {
      this.modelLoaded = false
    },
    // 模型切换
    handleModelChange(val) {
      this.modelLoaded = false
      this.modelFileInfo = this.modelList.find((item) => {
        return item.FileId === val
      })
    },
    // 获取场景list
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        name: '',
        folderId: '',
        maxResultCount: 999,
        skipCount: 0,
      })
      if (!err) {
        this.sceneList = res.items
        this.sceneId = this.sceneList[0] && this.sceneList[0].id
      }
    },
    // 获取模型列表
    async getModelList() {
      const [err, res] = await api.getModelData()
      if (!err) {
        let modelList = []
        console.log(res, '=======================')
        if (res.Data) {
          res.Data.forEach((item) => {
            modelList = [...modelList, ...item.Models]
          })
        }
        this.modelList = modelList
        console.log(this.modelList, 'this.modelList')
        if (modelList.length) {
          this.modelFileInfo = this.modelList[0]
          this.modelFileId = this.modelList[0].FileId
        }
      }
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['Tag3DPositionImgType'],
        includeDetails: true,
      })
      if (!err) {
        this.iconTypeList = res[0] && res[0].dataItems
        const findBasicItem = _.find(this.iconTypeList, (item) => {
          return item.code.toLowerCase() === 'base'
        })
        const findEffectItem = _.find(this.iconTypeList, (item) => {
          return item.code.toLowerCase() === 'effect'
        })
        this.basicImgType = findBasicItem && findBasicItem.id
        this.effectImgType = findEffectItem && findEffectItem.id

        this.getBasicIconList()
        this.getEffectIconList()
      }
    },
    // 打开设置
    async openSetting() {
      this.showMini = true
    },
    deviceTypeChange(code) {
      this.initPagination.pageNum = 1
      this.detailRow = {}
      this.deviceTypeInfo = _.find(this.deviceTypeList, { code }) || {}
      this.getBasicIconList()
      this.getEffectIconList()
      this.getList()
      this.renderStatus = false // 【查看】开关关闭
      this.editDialogShow = false
      this.switchStatus(false) // 清理三维上的图标和文本
    },
    // 切换查看状态
    switchStatus(res) {
      if (res) {
        // 打开查看三维图标
        this.cameraMarkerList = [] // 摄像头标记重置
        this.handleCameraData()
      } else {
        // 关闭三维图标
        this.delMarkers()
        this.delTextMarkers()
        this.$refs.editDialog && this.$refs.editDialog.delDraw() // 删除绘制的有效范围
      }
    },
    selectionChange(val) {
      this.selectionList = val
    },
    // 清空单个
    delRowData(row) {
      this.$confirm('是否清空', '提示', {
        confirmButtonText: '确定',
        cancelButtontext: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        this.clearMultiple([row.tag3DPositionDto.id])
      })
    },
    // 清空多个
    delMultiple() {
      if (Array.isArray(this.selectionList) && this.selectionList.length === 0) {
        this.$message.warning('请勾选要清空的数据!')
        return
      }
      this.$confirm('是否清空', '提示', {
        confirmButtonText: '确定',
        cancelButtontext: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        const ids = this.selectionList.map((item) => {
          return item.tag3DPositionDto && item.tag3DPositionDto.id
        })
        this.clearMultiple(ids)
      })
    },
    // 调用接口清除
    async clearMultiple(ids) {
      const [err] = await tag3DPositionManagementAPI.deleteMany({
        ids,
      })
      if (!err) {
        this.getList()
      }
    },
    // 获取设备类型
    async getDeviceType() {
      const [err, res] = await tag3DPositionManagementAPI.getTag3DPositionTagTypeList()
      if (!err) {
        this.deviceTypeList = res || []
        // 根据路由里的名称，把对应的设备类型值赋值给 this.deviceType
        const queryName = this.$route.query.code
        const findItem = this.deviceTypeList.find((n) => {
          return n.code.includes(queryName)
        })
        // 如果没有选择过设备类型，从url参数中获取对应的；url中没有参数，则默认取第一个
        if (!this.deviceType) {
          this.deviceType =
            (findItem && findItem.code) || (this.deviceTypeList[0] && this.deviceTypeList[0].code)
        }
        this.deviceTypeInfo = findItem || {}
        this.deviceType && this.getList()
      }
    },
    // 删除多行文本标记
    delTextMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.textMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.textMarkerIds = []
    },
    // 创建文本标记
    createTextMakers(item) {
      this.player.Native.GisMarker.loadImage(item.imgBackgroundColor || 'rgba:0,0,0,135', (id) => {
        const nameLength = item.name.length
        const textRows = Math.ceil((nameLength * 15) / 150)
        const imgHeight = textRows * 15 + 10
        const option = {
          pos: item.pos, // 定位点，世界坐标，三维向量
          nodeOffset: [18, -46], // 相对定位点的偏移量，二维向量
          imgId: id, // 图片id
          imgSize: [textRows > 1 ? 160 : nameLength * 15, imgHeight || 30], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
          text: item.name || '', // 文本
          textFontSize: 15.0, // 字体大小
          breakWidth: 150, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
          textColor: 0xffffffff, // 文本颜色
          title: null, // 标题
          contentPadding: [5, 5, 5, 5],
        }
        this.player.Native.GisMarker.create(option, (markerId) => {
          this.textMarkerIds.push({
            markerId,
          })
        })
      })
    },
    // 相机视角
    cameraPosition(res) {
      if (res.eye) {
        this.ruleForm.eye = res.eye.join()
        this.ruleForm.target = res.target.join()
        this.ruleForm.up = res.up.join()
        this.ruleForm.perspective = JSON.stringify(res)
      }
    },
    getCamaraPosition() {
      this.$refs.modelViewRef.getCameraPosition()
    },
    getPosition(info) {
      this.pointInfo = info
      // 如果在模型外点选，不操作;info.object, 模型内点击，有object字段，是一个包含被点中的模型信息
      if (info.object) {
        this.currentPosition = info ? info.pos : []
      } else {
        this.currentPosition = []
      }
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await tag3DPositionManagementAPI.getTag3DPositionTagInfoList({
        tagTypeCode: this.deviceType,
        keyWord: this.KeyWord,
        isPosition: this.IsPosition,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      if (!err) {
        res.items.forEach((item, index) => {
          const dtoInfo = item.tag3DPositionDto
          item.seqNo =
            (this.initPagination.pageNum - 1) * this.initPagination.pageSize + (index + 1)
          item.isSetPosition =
            dtoInfo && dtoInfo.threeDPosition && JSON.parse(dtoInfo.threeDPosition).length > 0
          item.isSetMonitorRange =
            dtoInfo &&
            dtoInfo.threeDMonitorRange &&
            JSON.parse(dtoInfo.threeDMonitorRange).length > 0
        })
        this.tableData = res.items || []
        this.initPagination.total = res.totalCount
        /* 如果三维已经加载完成，处理摄像头数据；比如编辑、删除后重新获取列表就属于这一类 */
        // if (this.modelLoaded) {
        //   this.cameraMarkerList = [] // 摄像头标记重置
        //   this.handleCameraData()
        // }
      }
      // this.tableLoading = false
    },
    rowClick(row) {
      if (row.isSetPosition) {
        const pos =
          (row.tag3DPositionDto.threeDPosition &&
            JSON.parse(row.tag3DPositionDto.threeDPosition)) ||
          []
        this.player.Native.Camera.moveToPos(pos, 0, 100, 1)
      }
    },
    editHandle(row) {
      this.detailRow = row
      this.editDialogShow = true
    },
    handleCameraData() {
      const cameras = this.tableData.filter((item) => {
        return item.tag3DPositionDto
      })
      // 摄像头标记信息
      const cameraMarkerList = cameras.map((camera) => {
        return {
          name: camera.name,
          pos:
            (camera.tag3DPositionDto.threeDPosition &&
              JSON.parse(camera.tag3DPositionDto.threeDPosition)) ||
            [],
          code: camera.code,
          cameraId: camera.tag3DPositionRelationKey,
          tagFileImgId: camera.tag3DPositionDto.tagFileImgId,
        }
      })
      this.cameraMarkerList = cameraMarkerList
    },
    // 创建摄像头标记
    createCameraMarker() {
      this.cameraMarkerList.forEach(async (camera) => {
        const basicIconInfo = this.basicIconList.find((item) => {
          return item.id === camera.tagFileImgId
        })
        const iconName = basicIconInfo && basicIconInfo.originalFileName
        console.log(iconName, 'icon')
        this.player.Native.GisMarker.loadImage(
          `data://../apps/gat/img/${iconName || 'icon-camara-blue.png'}`,
          (id) => {
            const option = {
              pos: camera.pos, // 定位点，世界坐标，三维向量
              // nodeOffset: camera.nodeOffset, // 相对定位点的偏移量，二维向量
              imgSize: [32, 50],
              nodeOffset: [-16, -50], // 相对定位点的偏移量，二维向量
              imgId: id, // 图片id
              visible: true,
            }
            this.player.Native.GisMarker.create(option, (markerId) => {
              this.cameraMarkerIds.push({
                markerId,
                // type: 'camera',
                // address: camera.address,
                // code: camera.code,
                // cameraId: camera.cameraId,
                // cameraType: camera.cameraType,
              })
            })
          }
        )
      })
    },
    // 删除标记
    delMarkers() {
      if (!this.player || !this.player.Native) return
      _.forEach(this.cameraMarkerIds, (marker) => {
        this.player.Native.GisMarker.destroy(marker.markerId)
      })
      this.cameraMarkerIds = []
    },
    // 标记点击
    markerClick(info) {
      const markerInfo = this.cameraMarkerIds.find((item) => {
        return item.markerId === info.markerId
      })
      if (markerInfo && markerInfo.type === 'camera' && markerInfo.code && markerInfo.cameraId) {
        this.cameraMsg = markerInfo
        this.videoDialogShow = true
      }
    },
    sendPlayer(player) {
      this.player = player
      this.player.Native.Settings.set('sys.autoUpdateFrame', 'bool', false)
    },
    loadModelEnd() {
      this.player.Native.ModelTree.EventBrowseLClick.connect(async (info) => {
        this.handlePointSelectPosition(info)
      })
      this.modelLoaded = true
    },
    // 处理点选
    handlePointSelectPosition(info) {
      // const positionArray = info.pos
      this.currentPosition = info ? info.pos : []
      // this.ruleForm.xPoint = positionArray[0]
      // this.ruleForm.yPoint = positionArray[1]
      // this.ruleForm.zPoint = positionArray[2]
    },
    // loadModelEnd() {
    //   this.modelLoaded = true
    //   this.player = this.$refs.modelViewRef.player
    //   this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
    // },
    handlePosition(pos) {
      this.detailRow = {
        ...this.detailRow,
        ...pos,
      }
    },
    // 取消编辑，隐藏弹窗
    handleCancelDevEdit() {
      this.editDialogShow = false
    },
    currentChange(val) {
      this.initPagination.pageNum = val
      this.getList()
    },
    sizeChange(val) {
      this.initPagination.pageNum = 1
      this.initPagination.pageSize = val
      this.getList()
    },
    // 获取设备类型下的基础图标列表
    async getBasicIconList() {
      const [err, res] = await tag3DPositionImgApi.findPagedTag3DPositionImgsList({
        // const [err, res] = await tag3DPositionImgApi.getList({
        imgType: this.basicImgType,
        tagTypeCode: this.deviceType,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err) {
        this.basicIconList = res && res.items
      }
    },
    // 获取设备类型下的效果图标列表
    async getEffectIconList() {
      const [err, res] = await tag3DPositionImgApi.findPagedTag3DPositionImgsList({
        imgType: this.effectImgType,
        tagTypeCode: this.deviceType,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err) {
        this.effectIconList = res && res.items
      }
    },
    // 编辑配置保存成功, 刷新设备类型列表、图标列表
    handleSaveSuccess() {
      this.editDialogShow = false
      // this.getDeviceType() // 设备类型因为编辑过，需要重新获取
      this.getBasicIconList()
      this.getEffectIconList()
    },
    // 设备详情
    openDeviceDetail() {
      this.showRelevanceDevices = true
    },
  },
  async created() {
    if (this.loadModelType === 'modelFileId') {
      this.getModelList()
    } else {
      this.getSceneList()
    }
    this.getDeviceType()
    this.getCategoryByCodes()
  },
  beforeDestroy() {
    console.log('beforeDestroy===')
    this.delMarkers()
    this.delTextMarkers()
    this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
  },
  deactivated() {
    console.log('deactivated===')
  },
}
</script>

<style lang="scss" scoped>
.point-set-container {
  overflow: hidden;
  display: flex;
  .left {
    width: 650px;
    background-color: var(--contentBgColor);
    position: relative;
    .point-set-dialog {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    .model-w {
      width: 100%;
      height: 100%;
    }
  }
}
.primary-blue {
  color: var(--tagSelectedText);
}
::v-deep .el-upload-dragger {
  height: 36px !important;
  width: 36px !important;
}
::v-deep .el-icon-upload {
  font-size: 32px;
  margin: 0;
  line-height: 36px;
}

.cameras,
.camera-container {
  height: 100%;
  overflow: hidden;
}
</style>
